import { authDispatcher } from '../auth';
import { LogoSmall } from '@/assets/svg';
import { urlLabel } from '@/enum/PermissionEnum';
import ModalConfirmationMobile from '@/new-components/CustomModal/ModalConfirmationMobile';
import customToast from '@/new-components/CustomNotification';
import { Box, Typography, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const CustomTitle = withStyles((theme) => ({
  root: {
    fontSize: 32,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: '#191919',
  },
}))(Typography);

const VerifySingpassScreen = ({ ...props }) => {
  const [showNoticeModal, setShowNoticeModal] = useState(false);
  const [loginInfo, setLoginInfo] = useState({});

  const history = useHistory();

  const queryParams = new URLSearchParams(props.location.search);
  const nonce = queryParams.get('nonce');
  const state = queryParams.get('state');
  const error = queryParams.get('error');
  const errorDescription = queryParams.get('error_description');
  const flow = localStorage.getItem('singpassFlow');

  useEffect(() => {
    if (error) {
      localStorage.removeItem('singpassFlow');
      customToast('error', errorDescription);
      history.push(`/${urlLabel.patientLogin}`);
      return;
    }

    authDispatcher.loginSingpass(
      {
        nonce,
        state,
      },
      (result) => {
        if (result) {
          if (result.isAuthorized) {
            setLoginInfo({
              ...result,
              nonce,
              state,
            });
            if (result.isExisted) {
              localStorage.removeItem('singpassFlow');
              authDispatcher.loginSuccess(result.accessToken, result?.email);

              setShowNoticeModal(false);
              history.push(`/${urlLabel.teleconsultNow}`);
            } else {
              authDispatcher.setState('singpassUserInfo', {
                ...result.singpassUserInfo,
                nonce,
                state,
              });
              localStorage.removeItem('singpassFlow');
              if (flow === 'signup') {
                // Self sign-up is closed - send them back to login.
                history.push(`/${urlLabel.patientLogin}`);
              } else {
                // From Sign In: show "no account" popup
                history.push(
                  `/${urlLabel.patientLogin}?singpassError=notRegistered`
                );
              }
            }
          } else {
            localStorage.removeItem('singpassFlow');
            history.push(`/${urlLabel.patientLogin}`);

            customToast(
              'error',
              'You have not completed Singpass authentication, please try again.'
            );
          }
        }
      },
      () => {
        localStorage.removeItem('singpassFlow');
        history.push(`/${urlLabel.patientLogin}?singpassError=notRegistered`);
      }
    );
  }, [
    error,
    errorDescription,
    history,
    loginInfo.accessToken,
    loginInfo.email,
    nonce,
    state,
  ]);

  return (
    <>
      {showNoticeModal && (
        <ModalConfirmationMobile
          open={showNoticeModal}
          onClose={() => {
            history.push(`/${urlLabel.patientLogin}`);
            setShowNoticeModal(false);
          }}
          onClick={() => {
            authDispatcher.loginSuccess(
              loginInfo.accessToken,
              loginInfo?.email
            );

            setShowNoticeModal(false);
            history.push(`/${urlLabel.teleconsultNow}`);
          }}
          title={
            <Box
              height={40}
              width="100%"
              position="relative"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <LogoSmall style={{ position: 'absolute', left: 0 }} />
              <CustomTitle style={{ fontSize: 18 }}>Notice</CustomTitle>
            </Box>
          }
          height={'unset'}
          subContent={
            <Box
              color="#292929"
              fontSize={16}
              px={2.5}
              mt={8}
              textAlign="left"
              height={'calc(100vh - 400px)'}
            >
              <p>
                Minmed Clinic (Kallang) is a MOH-licensed telemedicine provider.
              </p>
              <p>
                Telemedicine is suitable for non-emergency conditions. There are
                limitations and the consult may be cancelled without charge.
              </p>
              <p>
                Find out more in our{' '}
                <a
                  className="custom-link"
                  target="blank"
                  href="https://minmed.sg/teleconsult-doctor/#faq"
                >
                  FAQs
                </a>
                . Please proceed to the nearest Accident and Emergency facility
                if you need urgent medical attention.
              </p>

              <p>
                For any enquiries, please contact us at{' '}
                <a className="custom-link" href="mailto: ask@minmed.sg">
                  ask@minmed.sg
                </a>
                .
              </p>
            </Box>
          }
        />
      )}
    </>
  );
};

export default VerifySingpassScreen;
